import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/icon-prev.png'
import _imports_1 from '../images/icon-next.png'


const _withScopeId = n => (_pushScopeId("data-v-db3c15ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "swiper-wrapper" }
const _hoisted_2 = { class: "carousel-wrapper" }
const _hoisted_3 = ["data-bs-target"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon-prev"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "carousel-inner" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["data-bs-target"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "icon-next"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "carousel-indicators" }

import { onMounted, ref } from 'vue';

  export interface Image {
    url: string;
    text: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    images: null
  },
  setup(__props: any) {

  const carouselIntervalId = 'carouselInterval_' + Date.now().toString(36);
  const carousel = ref<HTMLElement>();
  const activeIndex = ref(0);

  

  onMounted(() => {
    (carousel.value as HTMLElement).addEventListener('slid.bs.carousel', function (e: any) {
      activeIndex.value = e.to;
    });
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "carousel-control-prev",
        type: "button",
        "data-bs-target": `#${carouselIntervalId}`,
        "data-bs-slide": "prev"
      }, _hoisted_5, 8, _hoisted_3),
      _createElementVNode("div", {
        id: carouselIntervalId,
        ref_key: "carousel",
        ref: carousel,
        class: "carousel slide",
        interval: false,
        "data-bs-ride": "carousel"
      }, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["carousel-item", { active: index === activeIndex.value }]),
              "data-bs-interval": "10000"
            }, [
              _createElementVNode("img", {
                src: item.url,
                class: "image"
              }, null, 8, _hoisted_7),
              _createElementVNode("div", {
                class: "text-wrapper",
                innerHTML: item.text
              }, null, 8, _hoisted_8)
            ], 2))
          }), 128))
        ])
      ], 512),
      _createElementVNode("button", {
        class: "carousel-control-next",
        type: "button",
        "data-bs-target": `#${carouselIntervalId}`,
        "data-bs-slide": "next"
      }, _hoisted_11, 8, _hoisted_9)
    ]),
    _createElementVNode("div", _hoisted_12, _toDisplayString(activeIndex.value + 1) + "/" + _toDisplayString(__props.images.length), 1)
  ]))
}
}

})